import React, { useEffect } from 'react';
import MaterialTable from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import { makeStyles } from '@material-ui/core/styles';
import { NavLink } from 'react-router-dom';
import Cookies from 'js-cookie';
import { TablePagination } from '@material-ui/core';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@material-ui/core';
import CloudQueueIcon from '@material-ui/icons/CloudQueue';
import CloudDoneIcon from '@material-ui/icons/CloudDone';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import API_PATH from "../../../constants/config.json";
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { Typography } from '@material-ui/core';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;
const AWS = require('aws-sdk');

//Start Css Code ...
const useStyles = makeStyles((theme) => ({
  filterTable: {
    '& .MuiTableCell-head': {
      fontWeight: '600',
      background: '#fff',
      color: '#000',
      border: '1px solid #d1d1d1',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '14pt',
        padding: '5px',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt',
        padding: '10px 5px',
      },
    },
    '& .MuiCheckbox-root': {
      padding: '0px',
    },
    '& .MuiFormControl-root': {
      border: '1px solid #24618E',
      borderRadius: '3px 3px 3px 3px',
      paddingLeft: '0px',
      position: 'absolute',
      width: '400px',
      top: '3px',
      '& .MuiIconButton-root.Mui-disabled': {
        color: '#fff',
      },
      '& :hover .MuiInputAdornment-positionEnd button': {
        color: '#24618E !important',
        fontWeight: '600 !important',
      },
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    },
    '& .MuiInputAdornment-positionStart': {
      background: '#24618E',
      height: '32px',
      width: '45px',
      color: '#fff',
      paddingLeft: '5px',
      borderRadius: '0px 3px 3px 0px',
      position: 'relative',
      left: '100%',
    },
    '& .MuiToolbar-root ': {
      paddingLeft: '0px',
      minHeight: '0px',
    },
    '& .MuiInput-root': {
      left: '-34px',
    },
    '& .MuiInputAdornment-positionStart svg': {
      fontSize: '25px !important',
    },
    '& td': {
      padding: '5px',
      border: '1px solid #D7D7D7',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '14pt !important',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '24pt !important',
      },
    },
    '& tr:nth-child(odd)': {
      backgroundColor: '#f2f2f2'
    },
    '& table': {
      borderRight: '1px solid #D7D7D7',
    },
    '& .MuiTableCell-head:nth-child(2)': {
      textAlign: 'left',
    },
    '& .MuiTableCell-body:nth-child(2)': {
      textAlign: 'left',
    },
    '& .MuiTablePagination-select': {
      color: '#000',
    },
  },
  addNewStation: {
    position: 'absolute',
    right: '0',
    border: '1px solid #333',
    padding: '5px 25px',
    color: '#333',
    textDecoration: 'none',
    fontSize: '14pt',
    borderRadius: '5px',
    top: '0px',
    marginRight: '6px',
    '&:hover': {
      boxShadow: '4px 3px 3px 0px #999',
    },
  },
  tdLink: {
    color: '#24618E',
    textDecoration: 'none',
  },
  deleteIcon: {
    color: '#333',
    fontFamily: 'Avenir_Black',
    fontWeight: '600',
    verticalAlign: 'middle',
    '@media only screen and (max-width: 3500px)': {
      fontSize: '20pt',
    },
    '@media only screen and (min-width: 3501px)': {
      fontSize: '30pt',
    },
    "&:hover": {
      color: "#CC0000",
      cursor: 'pointer',
    }
  },
  clearBtn: {
    border: '1px solid #333',
    color: '#333',
    width: '150px',
    marginRight: '10px',
    textTransform: 'capitalize',
    padding: '3px 5px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '& .MuiButton-root': {
      letterSpacing: '0',
    }
  },
  delBtn: {
    border: '1px solid #24618E',
    color: '#fff',
    background: '#24618E!important',
    width: '150px',
    marginRight: '10px',
    textTransform: 'capitalize',
    padding: '3px 10px',
    lineHeight: 'normal',
    letterSpacing: '0',
    '& .MuiButton-root': {
      letterSpacing: '0',
    }
  },
  header: {
    fontWeight: '800',
    color: '#24618d',
    fontFamily: 'Avenir_Black',
    fontSize: '18pt',
  },
  errorMsg: {
    backgroundColor: "#F2DEDE",
    border: "1px solid #CC0000",
    fontFamily: 'Avenir_Black',
    fontSize: '14pt',
    padding: '5px',
    marginBottom: '15px'
    , borderRadius: '5px'
  },
  heading: {
    fontFamily: '"Avenir_light" !important',
    fontSize: '14pt',
    lineHeight: '23px',
  },
  deletePopup: {
    '& .MuiDialogContent-root': {
      padding: '10px 15px',
    },
    '& .MuiPaper-root': {
      border: '1px solid #24618d',
      width: '525px',
    },
    '& .MuiDialogActions-root': {
      justifyContent: 'center',
      paddingTop: '30px'
    }
  },
  crossIcon: {
    color: '#24618d',
    fontSize: '20pt',
    fontFamily: 'Avenir_Black',
    fontWeight: '800',
    position: 'absolute',
    width: '40px !important',
    right: '5px',
    "&:hover": {
      cursor: 'pointer',
    }
  },
  loaderClass: {
    '& .MuiCircularProgress-root': {
      width: '20px !important',
      height: '15px !important',
      color: '#24618E',
      marginLeft: '30px !important',
      marginTop: '13px !important'
    }
  },
  headerIcon: {
    margin: '0px',
    '& svg': {
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt',
      },
    }
  },
  innerFileIcon: {
    margin: '0px',
    '& svg': {
      verticalAlign: 'middle',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt',
      },
    }
  },
  innerCloudIcon: {
    margin: '0px',
    '& svg': {
      verticalAlign: 'middle',
      color: '#006600',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt',
      },
    }
  }
}));
//End Css Code ...

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


//Start MidblockFiles component code ...
const MidblockFiles = props => {
  const [stationList, setStationList] = React.useState([]);
  const [pagination, setPagnation] = React.useState({ selectedPage: 1 });
  const [totalItems, setTotalItems] = React.useState(0);
  const [userAccess, setUserAccess] = React.useState(true);
  const [idintityPool, setIdintityPool] = React.useState('');
  const [aswLogins, setAswLogins] = React.useState('');
  const [errorDialogue, setErrorDialogue] = React.useState(false);

  const [myFileID, setMyFileId] = React.useState();
  const [open, setOpen] = React.useState(false);
  const [getFileName, setFileName] = React.useState();
  const [loader, setloader] = React.useState({ filename: "", loader: false });
  const [getLoader, setLoaderDisable] = React.useState(false);
  let enteriesPerPage = 25;

  const handleClickOpen = (file_id, origin_name) => {
    setMyFileId(file_id);
    setFileName(origin_name);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseDialogueBox = () => {
    setErrorDialogue(false);
  }

  const handleOpenDialogueBox = () => {
    setErrorDialogue(true);
  }

  
  let values = {
    "pageNo": pagination.selectedPage,
    "entriesPerPage": enteriesPerPage,
  }

  useEffect(
    () => {
      if (props.stationId) {
        getFileList(props.stationId);
        getAswToken();
      }
    }, [props.stationId]
  )

  const classes = useStyles();

  
//This method is use for API call to get file list ....  start
  const getFileList = (stationId, page = 1) => { 
    setLoaderDisable(true);
    try {
      axios({
        method: 'post',
        data: {
          stationId: stationId,
          pageNo: page,
          entriesPerPage: enteriesPerPage
        },
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
        url: API_URL + API_PATH.fileList,
      })
        .then(function (response) {
          if (response.status && response.status == '200') {
            setLoaderDisable(false);
            setStationList(response.data.data.rows);
            setTotalItems(response.data.data.count);
          } else {
            setStationList([]);
            setLoaderDisable(false);
          }
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.data.status == 403) {
              setUserAccess(false);
              setLoaderDisable(false);
              setStationList([]);
            } else {
              setLoaderDisable(false);
              setStationList([]);
            }
          } else {
            setLoaderDisable(false);
            setStationList([]);
          }
        })
    } catch (error) {
      setLoaderDisable(false);
      console.error(error);
    }
  }
  //This method is use for API call to get file list ....  end

  const handleSelected = (e, selectedPage) => {
    values.pageNo = selectedPage + 1;
    let page = values.pageNo
    setPagnation({ selectedPage: selectedPage + 1 })
    getFileList(props.stationId, page);
  }

  //This method is use for file rejection ... start
  const rejectFile = () => {
    try {
      axios({
        method: 'post',
        url: API_URL + API_PATH.rejectFile + myFileID,
        headers: {
          'payload': Cookies.get('payload'),
          'agencyid': sessionStorage.getItem('agency_id')
        },
      })
        .then(async function (response) {
          if (response.status && response.status == '200') {
            getFileList(props.stationId);
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    } catch (error) {
      console.error(error);
    }
    setOpen(false);
  }
  //This method is use for file rejection ... end


  //This method is use for get aws token for file download from s3 bucket ... start
  const getAswToken = () => {
    try {
      axios({
        method: 'get',
        url: API_URL + API_PATH.getAWSs3TokenAPI,
        headers: {
          'agencyid': sessionStorage.getItem('agency_id'),
          'payload': Cookies.get('payload'),
        },
      }).then(async function (response) {
        if (response.status && response.status == '200') {
          let aswData = response.data;
          setIdintityPool(aswData.data.IdentityPoolId);
          setAswLogins(aswData.data.Logins);
        } else {
          console.log("");
        }
      })
    } catch (error) {
      console.error(error);
    }
  }
  //This method is use for get aws token for file download from s3 bucket ... end
  

  //This method is use for download file from s3 bucket ... start
  const downloadFile = (file_id, bucketName, filename, originalFileName) => {
    setloader({ filename: file_id, loader: true });
    let OIDToken = Cookies.get('idToken');
    AWS.config.update(
      {
        region: 'us-west-2',
        credentials: new AWS.CognitoIdentityCredentials({
          IdentityPoolId: idintityPool,
          Logins: {
            [aswLogins]: OIDToken
          }
        })
      }
    );
    let s3 = new AWS.S3();
    s3.getObject({ Bucket: bucketName, Key: filename }, function (
      error,
      data
    ) {
      if (error != null) {
        handleOpenDialogueBox();
        loader.loader = false
        setloader(loader);
      } else {
        let blob = new Blob([data.Body], { type: data.ContentType });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = originalFileName;
        link.click();
        loader.loader = false
        setloader(loader);
      }
    });
  };
   //This method is use for download file from s3 bucket ... end

  return (
    <div className={classes.filterTable} data-testid='all_stations_table'>      
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.deletePopup}
      >
        <DialogTitle id="alert-dialog-title" style={{ borderBottom: "1px solid #00A75D", marginRight: '15px', marginLeft: '15px', padding: '7px 0px 0px 21px' }}>
          <Typography component={"h4"} className={classes.header} style={{ marginLeft: "-20px" }}>
            Delete File
          <FontAwesomeIcon icon={faTimes} className={classes.crossIcon} onClick={handleClose} />
          </Typography>
        </DialogTitle>

        <DialogContent>

          <Typography className={classes.errorMsg} >
            <InfoIcon style={{ color: '#CC0000', marginBottom: '-6px' }} />This action will premanently delete this file
          </Typography>

          <Typography gutterBottom className={classes.heading}>
            Proceeding with this action will permanently delete the following file from this station:
          </Typography>
          <Typography gutterBottom className={classes.heading} style={{ marginTop: '20px', wordBreak: 'break-all' }}>
            {getFileName}
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} className={classes.clearBtn} style={{ border: "1px solid #24618E", borderRadius: '5px', marginBottom: "10px" }}>
            Cancel
 </Button>
          <Button onClick={() => rejectFile()} className={classes.delBtn} style={{ border: "1px solid #24618E", borderRadius: '5px', marginRight: "10px", marginBottom: "10px" }}>
            Delete
 </Button>
        </DialogActions>
      </Dialog>

      {/* Error Dialogue Box */}

      <Dialog
        open={errorDialogue}
        onClose={handleCloseDialogueBox}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.deletePopup}
      >
        <DialogTitle id="alert-dialog-title" style={{ borderBottom: "1px solid #00A75D", marginRight: '15px', marginLeft: '15px', padding: '7px 0px 0px 21px' }}>
          <Typography component={"h4"} className={classes.header} style={{ marginLeft: "-20px" }}>
            Error
          <FontAwesomeIcon icon={faTimes} className={classes.crossIcon} onClick={handleCloseDialogueBox} />

          </Typography>
        </DialogTitle>

        <DialogContent>

          <Typography className={classes.errorMsg} >
            <InfoIcon style={{ color: '#CC0000', marginBottom: '-6px' }} /> File Downloading Failed!
          </Typography>

        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialogueBox} className={classes.clearBtn} style={{ border: "1px solid #24618E", borderRadius: '5px', marginBottom: "10px" }}>
            Ok
          </Button>

        </DialogActions>
      </Dialog>

      <MaterialTable
        icons={tableIcons}
        title=""
        columns={[
          {
            title: 'Date Imported', field: 'createdAt', cellStyle: {
              width: '5%',
              textAlign: 'left',
            },
            headerStyle: {
              width: '5%',
              textAlign: 'left',
            },
            render: rowData => {
              var d = new Date(rowData.createdAt);
              return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
            },
          },
          {
            title: <p title='Database import availability' className={classes.headerIcon}><CloudQueueIcon /></p>, sorting: false, cellStyle: {
              width: '2%',
              textAlign: 'center',
            },
            headerStyle: {
              width: '2%',
              textAlign: 'center',
            },
            render: rowData => rowData.FK_file_type_id === 5 ? <p className={classes.innerFileIcon} title='Database import not supported'> <InsertDriveFileOutlinedIcon /> </p> : <p className={classes.innerCloudIcon} title='Data available in database'> <CloudDoneIcon style={{ color: "#006600", verticalAlign: 'middle' }} /> </p>,
          },
          {
            title: 'File Name', field: 'origin_name', cellStyle: {
              width: '15%',
            },
            headerStyle: {
              width: '15%',
              textAlign: 'center',
            },
            render: rowData => <NavLink to="#" onClick={() => downloadFile(rowData.file_id, rowData.bucket_name, rowData.base_name, rowData.origin_name)} className={classes.tdLink} >{rowData.origin_name}<span className={classes.loaderClass}>{loader.filename === rowData.file_id && loader.loader ? <CircularProgress /> : null}</span></NavLink>,
          },
          {
            title: 'Imported By', field: 'imported_by', cellStyle: {
              width: '10%',
            },
            headerStyle: {
              width: '10%',
              textAlign: 'center',
            },
            render: rowData => <div> {rowData.imported_by} </div>
          },
          {
            title: '', field: '', sorting: false, cellStyle: {
              width: '1%',
            },
            headerStyle: {
              width: '1%',
              textAlign: 'center',
            },
            render: rowData => <p style={{ margin: '0', textAlign: 'center' }} title='Delete'><FontAwesomeIcon icon={faTimes} className={classes.deleteIcon} onClick={() => handleClickOpen(rowData.file_id, rowData.origin_name)} /></p>
          }
        ]}
        data={stationList ? stationList : []}
        totalCount={totalItems}
        options={{
          thirdSortClick: false,
          filtering: false,
          sorting: true,
          search: false,
          paging: true,
          pageSize: enteriesPerPage,
          pageSizeOptions: [0],
          maxBodyHeight:sessionStorage.getItem('MidTabWidth') >= 3501 ? (sessionStorage.getItem('midTabHeight') - 435).toString() + 'px' : (sessionStorage.getItem('midTabHeight') - 275).toString() + 'px',
          emptyRowsWhenPaging: false,
        }}
        components={
          userAccess == true ?
            getLoader == false ?
              {
                Pagination: props => (
                  <TablePagination
                    {...props}
                    count={totalItems}
                    page={pagination.selectedPage - 1}
                    onChangePage={handleSelected}
                    rowsPerPage={enteriesPerPage}
                  />
                ),
              }
              :
              {
                Pagination: props => (
                  <TablePagination
                    {...props}
                    count={totalItems}
                    page={pagination.selectedPage - 1}
                    onChangePage={handleSelected}
                    rowsPerPage={enteriesPerPage}
                  />
                ),
                Body: (props) => (
                  <tr style={{ height: '49px' }}><td colspan="5" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><CircularProgress /></span> </td></tr>
                )
              }
            : {
              Pagination: props => (
                <TablePagination
                  {...props}
                  count={totalItems}
                  page={pagination.selectedPage - 1}
                  onChangePage={handleSelected}
                  rowsPerPage={enteriesPerPage}
                />
              ),
              Body: (props) => (
                <tr style={{ height: '49px' }}><td colspan="4" style={{ paddingTop: '0px', paddingBottom: '0px', textAlign: 'center' }}><span style={{ color: '#CC0000', fontWeight: '600' }}><FontAwesomeIcon icon={faTimes} /> Access Forbidden</span> </td></tr>
              )
            }
        }
      />
    </div>
  )
}

export default MidblockFiles;
//Start MidblockFiles component code ...